export class MapDateRange {
  startDate?: Date | undefined;
  endDate?: Date | undefined;
  steps?: Date[] | undefined;
}
